<template>
  
  <b-card class="w-100">
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :pagination-options="{
        enabled: true,
        perPage: page_length,
      }"
      :sort-options="{
        enabled: true,
        initialSortBy: {field: 'created_at', type: 'desc'},
        multipleColumns: false,
      }"
      :rowStyleClass="getRowClass"
      class="vgt-table-list"
      styleClass="vgt-table bordered"
      @on-sort-change="onSortChange"
    >
      <template slot="table-column" slot-scope="props">
        <div v-if="props.column.field === 'campaign'" class="text-center">
          {{ $t(props.column.label) }}
        </div>
        <div v-if="props.column.field === 'created_at'" class="d-block text-center cursor-pointer">
          {{ $t(props.column.label) }}
          <b-icon icon="chevron-bar-expand" class="float-right"/>
        </div>
        <div v-if="props.column.field === 'note'" class="d-block text-center cursor-pointer">
          {{ $t(props.column.label) }}
        </div>
        <div v-if="props.column.field === 'status'" class="d-block text-center cursor-pointer">
          {{ $t(props.column.label) }}
        </div>
        <span v-if="props.column.field === 'actions'" class="d-block text-center">
          {{ $t(props.column.label) }}
        </span>
      </template>
      <template slot="table-row" slot-scope="props">
        <span
          v-if="props.column.field === 'campaign'"
          class="text-nowrap d-block text-start mt-1 mb-1"
        >
          <b-avatar
            class="mr-1"
            variant="light-primary"
            :src="props.row.campaing.logo"
          />
          {{props.row.title}}
        </span>
        <span v-else-if="props.column.field === 'created_at'" class="text-nowrap d-block text-center"> 
          <span>{{ props.row.created_at }}</span> 
        </span>
        <span v-if="props.column.field === 'note'" class="text-nowrap d-block text-center">
        <span>{{ props.row.note }}</span>
        </span>
        <span v-else-if="props.column.field === 'status'" class="text-nowrap d-block text-center">
          <b-badge pill :variant="getVariantStatus(props.row.status)" :class="getVariantStatus(props.row.status)">
            {{$t(`creator.${props.row.status}`)}}
          </b-badge>
        </span>
        <span v-else-if="props.column.field === 'actions'" class="text-nowrap d-block text-center">
          <b-link target="_blank" :href="props.row.url_download">{{ $t('mediaKits.download') }}</b-link>
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap">
              {{$t('campaigns.showing_to')}} {{ page_length }} {{$t('campaigns.of')}} {{ props.total }} {{$t('campaigns.entries')}}
            </span>
          </div>
          <div>
            <b-pagination
              :total-rows="total_results"
              :per-page="page_length"
              v-model="page"
              first-number
              last-number
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="
                (value) => props.pageChanged({ currentPage: value })
              "
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>

</template>

<script>
import { VueGoodTable } from "vue-good-table";
import { getExportsCampaign } from '@/services/campaign';

import {
  BAvatar,
  BCard, 
  BPagination,
  BLink,
  BBadge
} from 'bootstrap-vue';

export default {
  name: "AccountSettingsExportReportsCampaign",
  components: {
    BAvatar,
    BCard,
    VueGoodTable,
    BPagination,
    BLink,
    BBadge
  },
  data() {
    return {
      columns: [
        {
          label: "creator.casting_call",
          field: "campaign",
          sortable: false,
        },
        {
          label: "campaigns.created_at",
          field: "created_at",
          sortable: true,
        },
        {
          label: "campaigns.note",
          field: "note",
          sortable: false,
        },
        {
          label: "campaigns.status",
          field: "status",
          sortable: false,
        },
        {
          label: "lists.actions",
          field: "actions",
          sortable: false,
        }
      ],    
      rows: [],
      page_length: 100,
      page: 1,
      total_results: 0,
      order_by: '-status',
      highlight_uuid: null,
    };
  },
  created() {
    this.getExports(true);
    const uuid = this.$route.query.uuid;
    if (uuid) {
      this.highlight_uuid = uuid;
      this.removeQueryParam('uuid');
    }

    this.$root.$on('export_summaries_complete', (uuid) => {
      this.highlight_uuid = uuid;
      this.getExports(true);
    });
  },
  methods: {
    getVariantStatus(status) {
      if (status === 'processing') return 'light-warning'
      if (status === 'complete') return 'light-success'
      if (status === 'error') return 'light-danger'
      return 'light-warning';
    },
    onSortChange(params) {
      const filed = params[0].field;
      const order = params[0].type;

      if (order === 'asc') {
        this.order_by = filed;
      } else {
        this.order_by = `-${filed}`;
      }
      this.getExports();
    },
    getExports(check_uuid = false) {
      getExportsCampaign(this.page_length, this.page, {order_by: this.order_by}).then((response) => {
        this.rows = response.results;
        this.total_results = response.count;

        if (check_uuid) {
          if (check_uuid) this.highlightRow();
        }
      })
    },
    highlightRow() {
      const row = this.rows.find(row => row.uuid === this.highlight_uuid);
      if (row) {
        this.$nextTick(() => {
          const element = document.querySelector(`.row-uuid-${row.uuid}`);
          if (element) {
            element.classList.add('fade-in');
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });

        setTimeout(() => {
          const fadingRow = document.querySelector(`.row-uuid-${this.highlight_uuid}`);
          if (fadingRow) {
            fadingRow.classList.remove('fade-in');
            fadingRow.classList.add('fade-out');
          }

          setTimeout(() => {
            if (fadingRow) {
              fadingRow.classList.remove('fade-out');
            }
            this.highlight_uuid = null;
          }, 250);
        }, 1000);
      }
    },
    getRowClass(row) {
      const baseClass = row.uuid === this.highlight_uuid ? 'highlight-row selected-row' : '';
      return `row-uuid-${row.uuid} ${baseClass}`;
    },
    removeQueryParam(param) {
      const url = new URL(window.location.href);
      url.searchParams.delete(param);
      window.history.replaceState({}, '', url.toString());
    }
  },
  watch: {
    page() {
      this.getExports();
    }
  }
};
</script>

<style>
  .vgt-table-list {
    overflow-x: scroll;
  }
  .vgt-table-list table {
    width: 100% !important;
  }
  .container-avatar-table {
    position: relative;
  }
  .container-avatar-table-icon {
    position: absolute; 
    bottom: -5px; 
    right: -15px;
  }
  .style-border-icon {
    font-size:1em; 
    border-radius: 50%; 
    background: white; 
    padding: 2px
  }
  .highlight-row {
    background-color: #f0f8ff !important;
  }
  .selected-row {
    border: 2px solid #81b9f5 !important;
    box-shadow: 0 0 10px rgba(86, 159, 237, 0.5);
    transition: all 1s ease-in-out;
    margin-bottom: 10px;
  }
  .fade-in {
    opacity: 0;
    animation: fadeIn 1s forwards;
  }
  .fade-out {
    opacity: 1;
    animation: fadeOut 1s forwards;
  }
  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
  @keyframes fadeOut {
    from {
      opacity: 1;
    }
    to {
      opacity: 0;
    }
  }
</style>